import React, {useRef} from "react"
import * as AdaptiveCards from "adaptivecards"
import Styles from "./card.less"
import {useMount} from "ahooks"
import {config} from "./config"

export interface CardProps {
    data: any
    onCardClick: (param: CardClickAction) => void
}

export interface CardClickAction {
    data: CardClickActionData
    type?: string
    url?: string
}

export interface CardClickActionData {
    eventData: any
    eventType: string
    url?: string
}

const Card: React.FC<CardProps> = ({data, onCardClick}) => {
    const containerRef = useRef<HTMLDivElement>(null)

    useMount(() => {
        let adaptiveCard = new AdaptiveCards.AdaptiveCard()
        adaptiveCard.hostConfig = new AdaptiveCards.HostConfig({
            ...config,
        })
        // @ts-ignore
        adaptiveCard.onExecuteAction = onCardClick
        AdaptiveCards.AdaptiveCard.onProcessMarkdown = function (text, result) {
            result.outputHtml = text
            result.didProcess = false
        }
        adaptiveCard.parse(data)
        let renderedCard = adaptiveCard.render()
        containerRef.current?.appendChild(renderedCard)
    })

    return <div className={Styles["card-wrapper"]} ref={containerRef} />
}

export default Card
